export const COLLAR_COLORS = [
    "red",
    "blue",
    "green",
    "yellow",
    "pink",
    "black",
    "orange",
    "purple",
];
// Gesamtpreis (cents) je Menge. Index 0 = 1 Halsband. Einzelpreis sinkt
// staffelweise von 15,00 € (1 Stk) auf 10,00 € (10 Stk).
export const COLLAR_PRICE_TIERS_CENTS = [
    1500, // 1  — 15,00 €/Stk
    2800, // 2  — 14,00 €/Stk
    3900, // 3  — 13,00 €/Stk
    5000, // 4  — 12,50 €/Stk
    6000, // 5  — 12,00 €/Stk
    6900, // 6  — 11,50 €/Stk
    7700, // 7  — 11,00 €/Stk
    8600, // 8  — 10,75 €/Stk
    9500, // 9  — 10,56 €/Stk
    10000, // 10 — 10,00 €/Stk
];
// Mini-Anhänger (QR-Tag fürs vorhandene Halsband) — günstiger als das Halsband.
// Einzelpreis sinkt staffelweise von 10,00 € (1 Stk) auf 6,50 € (10 Stk).
export const MINI_TAG_PRICE_TIERS_CENTS = [
    1000, // 1  — 10,00 €/Stk
    1800, // 2  —  9,00 €/Stk
    2550, // 3  —  8,50 €/Stk
    3200, // 4  —  8,00 €/Stk
    3800, // 5  —  7,60 €/Stk
    4350, // 6  —  7,25 €/Stk
    4900, // 7  —  7,00 €/Stk
    5400, // 8  —  6,75 €/Stk
    5900, // 9  —  6,56 €/Stk
    6500, // 10 —  6,50 €/Stk
];
export function collarPriceCents(quantity) {
    if (quantity < 1 || quantity > 10)
        throw new Error("quantity 1..10");
    return COLLAR_PRICE_TIERS_CENTS[quantity - 1];
}
// Gesamtpreis je Produkttyp + Menge.
export function productPriceCents(type, quantity) {
    if (quantity < 1 || quantity > 10)
        throw new Error("quantity 1..10");
    const tiers = type === "tag" ? MINI_TAG_PRICE_TIERS_CENTS : COLLAR_PRICE_TIERS_CENTS;
    return tiers[quantity - 1];
}
export const SHIPPING_OPTIONS = {
    brief: { cents: 100, insured: false },
    paket: { cents: 350, insured: true },
};
export function shippingCents(method) {
    return SHIPPING_OPTIONS[method]?.cents ?? SHIPPING_OPTIONS.brief.cents;
}
export const SMS_COST_CENTS = 50;
// Desktop-Geräte (aus dem User-Agent, siehe server/modules/useragent.ts).
// Ein echter Finder scannt unterwegs mit dem Handy — ein Scan von einem Rechner
// ist praktisch immer ein Fehlalarm (Eigen-/Testaufruf). Solche Scans lösen
// keine Benachrichtigung aus und werden in der Liste als Fehlalarm markiert.
export const DESKTOP_DEVICE_LABELS = ["Mac", "Windows-PC", "Linux-PC", "Chromebook"];
export function isDesktopScan(device) {
    return !!device && DESKTOP_DEVICE_LABELS.includes(device);
}
export const SMS_TOPUP_PACKAGES_CENTS = [500, 1000, 2000];
//# sourceMappingURL=constants.js.map